import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
	selectIsAppAdmin,
	selectIsApprover,
	selectIsSysAdmin,
	selectIsCmeUser,
	selectIsCmeCoordinator,
} from "reducers/securitySlice";
import { useSelector, useDispatch } from "react-redux";
import { appContextEdited } from "reducers/formSlice";
import { homePathEdited, selectGlobal } from "reducers/global";

export const USER = "user";
export const APPROVER = "approver";
export const ADMIN = "admin";
export const SYSADMIN = "sysadmin";
export const COORDINATOR = "coordinator";

//usage useSecurity([type])
//this will auto redirect if user does not have appropriate access
export const useSecurity = (type, redirect = true) => {
	const dispatch = useDispatch();
	const history = useHistory();
	const homePath = useSelector(selectGlobal).homePath;
	const isCmeUser = useSelector(selectIsCmeUser);
	const isCmeApprover = useSelector(selectIsApprover);
	const isCmeAdmin = useSelector(selectIsAppAdmin);
	const isCmeSysAdmin = useSelector(selectIsSysAdmin);
	const isCmeCoordinator = useSelector(selectIsCmeCoordinator);

	useEffect(() => {
		//if user is signing in for the first time, and homepath is not set
		//we set it from here.
		//later, the homePath can be overridden by other screens

		const defaultHomePath =
			type === USER
				? "/CME/Dashboard"
				: type === APPROVER
				? "/CME/ApproverDashboard"
				: type === ADMIN
				? "/CME/Admin"
				: type === SYSADMIN
				? "/CME/Admin"
				: type === COORDINATOR
				? "/CME/Coordinator"
				: null;
		if (!homePath && type) {
			dispatch(homePathEdited(defaultHomePath));
		}
	}, [homePath, dispatch, type]);

	useEffect(() => {
		if (redirect) {
			// first dispatch appContext
			if (type) dispatch(appContextEdited(type));
			// admins -> return
			if (isCmeSysAdmin) return;
			if (type === USER && !isCmeUser && !isCmeAdmin)
				history.push("/CME/Unauthenticated/NotCmeUser");
			if (type === APPROVER && !isCmeApprover && !isCmeAdmin)
				history.push("/CME/Unauthenticated/NotCmeApprover");
			if (type === ADMIN && !isCmeAdmin)
				history.push("/CME/Unauthenticated/NotCmeAdmin");
			if (type === COORDINATOR && !isCmeCoordinator && !isCmeAdmin)
				history.push("/CME/Unauthenticated/NotCmeAdmin");
			if (type === SYSADMIN && !isCmeSysAdmin)
				history.push("/CME/Unauthenticated/NotCmeSysAdmin");
		}
	}, [
		dispatch,
		history,
		type,
		isCmeUser,
		isCmeApprover,
		isCmeAdmin,
		isCmeSysAdmin,
		isCmeCoordinator,
		redirect,
	]);

	return {
		isCmeUser,
		isCmeApprover,
		isCmeAdmin,
		isCmeSysAdmin,
		isCmeCoordinator,
	};
};
